// extracted by mini-css-extract-plugin
export default {"add-deviations-overlay":"_2GFVA","addDeviationsOverlay":"_2GFVA"};